import { TabPanel } from "@mui/lab";
import { Box, Button, CircularProgress, Backdrop, ThemeProvider, Typography } from "@mui/material";
import { muiTheme } from "system/styles/muiTheme";
import { useState } from "react";
import { useApi } from "system/hooks";
import { ConfirmationDialog, SuccessMessage } from "components/ui";
import { Icon } from "@fluentui/react";

export const RolesTab = () => {
  const api = useApi();
  const [confirmationDialogVisible, setConfirmationDialogVisible] = useState(false);
  const [successMessageVisible, setSuccessMessageVisible] = useState(false);
  const [successMessageTitle, setSuccessMessageTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCreateRoles = async () => {
    setConfirmationDialogVisible(false);
    setErrorMessage("");
    setLoading(true);
    try {
      const response = await api.admin.createRoles();
      if (response.isSuccess) {
        setSuccessMessageTitle(response.title ?? "Roles created successfully!");
        setSuccessMessageVisible(true);
      } else {
        setErrorMessage(response.failMessage ?? "Failed to create roles.");
      }
    } catch (error) {
      setErrorMessage("An error occurred while creating roles.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TabPanel value="roles">
        <ThemeProvider theme={muiTheme}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "5px" }}>
            <Button
              className="admin-buttons"
              variant="contained"
              onClick={() => setConfirmationDialogVisible(true)}
              sx={{
                backgroundColor: "#1a73e8",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#1669c1",
                },
              }}
            >
              Create Missing Roles for all the customers
              <div className="roles-icon">
                <Icon iconName="AddGroup" />
              </div>
            </Button>
          </Box>
          {errorMessage && <Box sx={{ color: "#d32f2f", marginTop: "10px" }}>{errorMessage}</Box>}
        </ThemeProvider>
      </TabPanel>

      <Backdrop
        open={loading}
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress color="inherit" size={64} />
        <Typography variant="h6" sx={{ mt: 2, textAlign: "center" }}>
          Creating roles... This process may take a while, please wait
        </Typography>
      </Backdrop>

      <ConfirmationDialog
        title="Create Missing Roles for all the customers"
        subText="Are you sure you want to create missing roles for all customers?"
        isVisible={confirmationDialogVisible}
        onConfirm={handleCreateRoles}
        onCancel={() => setConfirmationDialogVisible(false)}
        variant="success"
        confirmText="Create Roles"
      />
      <SuccessMessage
        isVisible={successMessageVisible}
        onConfirm={() => setSuccessMessageVisible(false)}
        title={successMessageTitle}
        message="The roles have been created or verified successfully."
      />
    </>
  );
};
